import { Component, OnInit } from '@angular/core';

interface ExtraOption {
  key: string;
  translationKey: string;
}

@Component({
  selector: 'app-call-details',
  templateUrl: './call-details.component.html',
  styleUrls: ['./call-details.component.scss'],
})
export class CallDetailsComponent implements OnInit {
  selectedPassengers = 1;
  showExtras = false;
  showNotes = true;
  isPriorityService = false;

  // Lista dinámica de extras disponibles
  availableExtras: ExtraOption[] = [
    { key: 'adapted_taxi', translationKey: 'services.adapted_taxi' },
    { key: 'baby_seat', translationKey: 'services.baby_seat' },
    { key: 'animal', translationKey: 'services.animal' },
    { key: 'bikes', translationKey: 'services.bikes' },
    { key: 'scooters', translationKey: 'services.scooters' },
    { key: 'low_car', translationKey: 'services.low_car' },
    { key: 'car5_2', translationKey: 'services.car5_2' },
    { key: 'large_trunk', translationKey: 'services.large_trunk' },
    { key: 'booster_seat', translationKey: 'services.booster_seat' }
  ];

  // Opciones de extras seleccionadas (se genera dinámicamente)
  selectedExtras: { [key: string]: boolean } = {};

  notes = '';

  constructor() {
    this.initializeExtras();
  }

  ngOnInit() { }

  private initializeExtras() {
    // Inicializar selectedExtras dinámicamente basado en availableExtras
    this.availableExtras.forEach(extra => {
      this.selectedExtras[extra.key] = false;
    });
  }

  onPassengerChange(event: any) {
    this.selectedPassengers = event.detail.value;
  }

  onExtrasToggle(event: any) {
    this.showExtras = event.detail.checked;
    if (!this.showExtras) {
      // Reset extras when disabled (dinámicamente)
      this.resetExtras();
    }
  }

  private resetExtras() {
    this.availableExtras.forEach(extra => {
      this.selectedExtras[extra.key] = false;
    });
  }

  onNotesToggle(event: any) {
    this.showNotes = event.detail.checked;
    if (!this.showNotes) {
      this.notes = '';
    }
  }

  onPriorityToggle(event: any) {
    this.isPriorityService = event.detail.checked;
  }

  onExtraChange(extraKey: string, event: any) {
    this.selectedExtras[extraKey] = event.detail.checked;
  }

}
